import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import { SingleInput, ShortcutValue } from '@warrenbrasil/nebraska-web';

import { IShortcutValue } from './types';

interface Props {
  shortcutValue: IShortcutValue[];
  status?: string;
  value?: number;
  helperText?: string;
  loading?: boolean;
}
interface EmitEvents {
  (event: 'change', value: number): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InputQuantity',
  props: {
    shortcutValue: null,
    status: { default: '' },
    value: { default: 0 },
    helperText: { default: '' },
    loading: { type: Boolean, default: false }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'change', value: number): void;
}), expose: any, slots: any, attrs: any }) {





const quantityValue = ref('0');

function handleChange(value: string) {
  quantityValue.value = value;

  emitChange();
}

function onClear() {
  quantityValue.value = '0';

  emitChange();
}

function shortcutClick(data: IShortcutValue) {
  quantityValue.value = (Number(quantityValue.value) + data.value).toString();

  emitChange();
}

function emitChange() {
  emit('change', Number(quantityValue.value));
}

return { __sfc: true,emit, quantityValue, handleChange, onClear, shortcutClick, emitChange, SingleInput, ShortcutValue }
}

})